<div class="featuredListHolder">
    <div class="title" [innerHTML]="title | safeHtml"></div>

    <div class="moviesHolder">

        <app-featured-card [movie]="movie" *ngFor="let movie of movies"></app-featured-card>

    </div>
</div>